import styled from 'styled-components';
import { getTextTokenPreset } from '@optimus-web/common';
import { OpenableOverlay } from '../OpenableOverlay';
import { Stack, StackProps } from '../Stack';
import { Ellipticable, getEllipticableCss } from '../typography';

export const PopoverElement = styled.div`
    background: ${({ theme }) => theme.designTokens.BACKGROUND_STATIC_FLOATING};
    box-shadow: ${({ theme }) => theme.designTokens.SHADOW_200};
    border-radius: ${({ theme }) => theme.designTokens.BORDER_RADIUS_100}px;
    padding: ${({ theme }) => theme.designTokens.SPACING_150}px;
`;

export const Arrow = styled.div`
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
`;

export const StyledOpenableOverlay = styled(OpenableOverlay)`
    padding: ${({ theme }) => theme.designTokens.SPACING_50}px;
    background: none;
    box-shadow: none;
    overflow: initial !important;

    &[data-popper-placement='bottom'] {
        ${Arrow} {
            border-width: 0 4px 4px 4px;
            border-color: transparent transparent ${({ theme }) => theme.designTokens.BACKGROUND_STATIC_FLOATING}
                transparent;
            top: 0;
        }
    }
    &[data-popper-placement='top'] {
        ${Arrow} {
            border-width: 4px 4px 0 4px;
            border-color: ${({ theme }) => theme.designTokens.BACKGROUND_STATIC_FLOATING} transparent transparent
                transparent;
            bottom: 0;
        }
    }
    &[data-popper-placement='right'] {
        ${Arrow} {
            border-width: 4px 4px 4px 0;
            border-color: transparent ${({ theme }) => theme.designTokens.BACKGROUND_STATIC_FLOATING} transparent
                transparent;
            left: 0;
        }
    }
    &[data-popper-placement='left'] {
        ${Arrow} {
            border-width: 4px 0 4px 4px;
            border-color: transparent transparent transparent
                ${({ theme }) => theme.designTokens.BACKGROUND_STATIC_FLOATING};
            right: 0;
        }
    }
`;

export const PopoverHeaderElement = styled(Stack)<StackProps>`
    margin-bottom: ${({ theme }) => theme.designTokens.SPACING_150}px;
`;

export const PopoverTitle = styled.h2<Ellipticable>`
    margin: ${({ theme }) => theme.designTokens.SPACING_0};
    color: ${({ theme }) => theme.designTokens.TEXT_STATIC_PRIMARY};
    ${getTextTokenPreset('BODY_L_STRONG')};
    ${getEllipticableCss}
`;

export const PopoverSubtitle = styled.p`
    margin: ${({ theme }) => theme.designTokens.SPACING_0};
    color: ${({ theme }) => theme.designTokens.TEXT_STATIC_SECONDARY};
    ${getTextTokenPreset('BODY_S')};
`;
